'use strict';

export { startWebLayoutAnimation, tryActivateLayoutTransition } from "./animationsManager.js";
export { getReducedMotionFromConfig, saveSnapshot } from "./componentUtils.js";
export { configureWebLayoutAnimations } from "./domUtils.js";
//# sourceMappingURL=index.js.map